import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GhiseulUnicSettingsComponent } from './ghiseul-unic-settings.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ZileLibereModule } from './zile-libere/zile-libere.module';
import { GhiseuModuleModule } from './ghiseu-module/ghiseu-module.module';
import { LocatiiModule } from './locatii/locatii.module';
import { ServiciiModule } from './servicii/servicii.module';
import { ModuleLocatiiModule } from './module-locatii/module-locatii.module';
import { LocatiiServiciiModule } from './locatii-servicii/locatii-servicii.module';
import { ModLocServiciiModule } from './mod-loc-servicii/mod-loc-servicii.module';
import { ProgramariBlocareModule } from './programari-blocare/programari-blocare.module';
import { ProgramariUltimaOraModule } from './programari-ultima-ora/programari-ultima-ora.module';
import { TipProgramModule } from './tip-program/tip-program.module';
import { TipProgramActiveModule } from './tip-program-active/tip-program-active.module';
import { OperatoriModule } from './operatori/operatori.module';
import { TipProblemaModule } from './tip-problema/tip-problema.module';
import { TipProblemaServiciiModule } from './tip-problema-servicii/tip-problema-servicii.module';
import { StatusModule } from './status/status.module';
import { PrioritiesModule } from './priorities/priorities.module';

@NgModule({
    declarations: [GhiseulUnicSettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        ZileLibereModule,
        GhiseuModuleModule,
        LocatiiModule,
        ServiciiModule,
        ModuleLocatiiModule,
        LocatiiServiciiModule,
        ModLocServiciiModule,
        ProgramariBlocareModule,
        ProgramariUltimaOraModule,
        TipProgramModule,
        TipProgramActiveModule,
        OperatoriModule,
        TipProblemaModule,
        TipProblemaServiciiModule,
        StatusModule,
        PrioritiesModule
    ],
    exports: [GhiseulUnicSettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GhiseulUnicSettingsModule { }
